export const actionTypes = {
  SET_BANK: 'PROFILE.ACCOUNTS_ABROAD.LIST_FILTERS.SET_BANK',
  SET_ACCOUNT_STATUS: 'PROFILE.ACCOUNTS_ABROAD.LIST_FILTERS.SET_ACCOUNT_STATUS',
};

export function setBank(bankOption) {
  return {
    type: actionTypes.SET_BANK,
    payload: bankOption,
  };
}

export function setAccountStatus(accountStatusOption) {
  return {
    type: actionTypes.SET_ACCOUNT_STATUS,
    payload: accountStatusOption,
  };
}
